import React, { FC } from 'react';
import TypographyComponent from 'components/Typography/Typography';
import * as Styled from './ContactRepModalView.styles';

interface CheckboxProps {
  title: string;
  checked: boolean;
  onChange: (isChecked: boolean) => void;
  disabled?: boolean;
}

export const Checkbox: FC<CheckboxProps> = ({
  title,
  checked,
  onChange,
  disabled,
}) => {
  const [isChecked, setIsChecked] = React.useState(checked);

  const handleOnChange = () => {
    setIsChecked(!isChecked);
    onChange(!isChecked);
  };

  return (
    <Styled.ContactRepModalCheckbox
      onClick={handleOnChange}
      disabled={disabled}
    >
      <Styled.Checkbox
        size={24}
        backgroundColor="white"
        hasBorder={true}
        checked={isChecked}
        onClick={handleOnChange}
      />
      <TypographyComponent variant="body">{title}</TypographyComponent>
    </Styled.ContactRepModalCheckbox>
  );
};
